import { List, useTranslate } from 'react-admin';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import { DashboardContent } from '../../../../layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import { Resources } from '../resource';
import { InviteBetaCodeConfigForm } from './InviteBetaCodeConfigForm';

const View = () => {
  const translate = useTranslate();
  return (
    <PermissionGuard
      resource="invite-beta-code-config"
      action="read"
      fallback={<ErrorPage403 />}
    >
      <DashboardContent>
        <CustomBreadcrumbs heading={translate('module.invite-codes.inviteBetaCodeConfig') } />
        <InviteBetaCodeConfigForm />
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;

